module.exports = __webpack_public_path__ + "media/images/riders/MARCO_AURELIO_FONTANA-e8265be31069eeb54cf6a6e19cbc894e.png";